import React from "react";
import { Helmet } from "react-helmet-async";

export const GlobalHead: React.FC = () => {
  return (
    <Helmet>
      {/* Add other global meta tags if needed */}
      {/* <script
        src="https://analytics.ahrefs.com/analytics.js"
        data-key="PBlxGK14CRWXh4XMTs6Rmg"
        async
      ></script> */}
    </Helmet>
  );
};
